import { render } from "./ViewPartners.vue?vue&type=template&id=efc435a2"
import script from "./ViewPartners.vue?vue&type=script&lang=js"
export * from "./ViewPartners.vue?vue&type=script&lang=js"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__